import React, { useEffect, useState } from "react";
import { BasicAnnualPriceID, BasicMonthlyPriceID, TestBasicAnnualPriceID, TestBasicMonthlyPriceID } from "../tiers/Basic";
import { TestFoundersClubMonthlyPriceID, TestFoundersClubAnnualPriceID, FoundersClubMonthlyPriceID, FoundersClubAnnualPriceID } from "../tiers/foundersclub";
import { useDataManager } from "../backend/DataManager";
import { ProAnnualPriceID, ProMonthlyPriceID, TestProAnnualPriceID, TestProMonthlyPriceID } from "../tiers/Pro";
import { paymentServerURL } from "../backend/ApiURLs";

export default function ExistingUserCheckout() {

    const {priceIDToBuyMonth, setPriceIDToBuyMonth, priceIDToBuyAnnual, setPriceIDToBuyAnnual, customerID, setCustomerID, isFoundersClub, setIsFoundersClub} = useDataManager();
    const isReturningCustomer = true

    const [priceIDToSend, setPriceIDToSend] = useState("")
    const [tier, setTier] = useState("")
    const [subscription_length, setSubscription_length] = useState("")
    const [founders, setFounders] = useState("")

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const createCreateCheckoutSessionURL = `${paymentServerURL}create-checkout-session-for-existing-user`

    const isInTestingEnvironment = false

    const handleSubmit = () => {
      setIsSubmitting(true)

      const isValidInputs = validateInputs(tier, subscription_length)

      if (isValidInputs != "") {
        setErrorMessage(isValidInputs)
        setIsSubmitting(false)
        return
      }


      const { priceID, error } = convertInputsForServerDependingFounders();
      setPriceIDToSend(priceID)

      if (error) {
        setErrorMessage(error);
        setIsSubmitting(false);
        return;
      }

      // runs handleNetworkRequest after priceID is set
    }

      
      // Using useEffect to trigger the network request after priceID is set
      useEffect(() => {
        if (priceIDToSend) {
          HandleNetworkRequest();
        }
      }, [priceIDToSend]);  // Dependency array ensures this runs when priceID changes


    const validateInputs = (tier, subscription_length) => {
      if (tier == "") {
        return "Please select a tier"
      }

      if (subscription_length == "") {
        return "Please select a subscription length"
      }

      return ""

    }

    const convertInputsForServerDependingFounders = () => {
      const isPro = tier === "2";

      var priceMap = null
    
      if (isInTestingEnvironment) {
      priceMap = {
        "1 Month": isPro
          ? (isFoundersClub ? TestFoundersClubMonthlyPriceID : TestProMonthlyPriceID)
          : TestBasicMonthlyPriceID,
        "12 Months": isPro
          ? (isFoundersClub ? TestFoundersClubAnnualPriceID : TestProAnnualPriceID)
          : TestBasicAnnualPriceID,
      };
      } else {
      priceMap = {
        "1 Month": isPro
          ? (isFoundersClub ? FoundersClubMonthlyPriceID : ProMonthlyPriceID)
          : BasicMonthlyPriceID,
        "12 Months": isPro
          ? (isFoundersClub ? FoundersClubAnnualPriceID : ProAnnualPriceID)
          : BasicAnnualPriceID,
      };
      }

    
      const selectedPriceID = priceMap[subscription_length];
    
      if (!selectedPriceID) {
        return { priceID: "", error: "Cannot find priceID. Please contact support" };
      }
    
      return { priceID: selectedPriceID, error: "" };
    };
    

        /**
     * @deprecated Founders club is over. Need to convert inputs dynamically by founders club input from previous page
     * Use `sendLoginRequestForExistingUserRenewalDetailsObject` instead.
     */
    const convertInputsForServerAlwaysFounders = () => {
      const isPro = tier === "2";
      setFounders(isPro);
    
      const priceMap = {
        "1 Month": isPro ? FoundersClubMonthlyPriceID : BasicMonthlyPriceID,
        "12 Months": isPro ? FoundersClubAnnualPriceID : BasicAnnualPriceID,
      };
    
      const selectedPriceID = priceMap[subscription_length];
    
      if (!selectedPriceID) {
        return { priceID: "", error: "Cannot find priceID. Please contact support" };
      }
    
      return { priceID: selectedPriceID, error: "" };
    };
    
    
    const HandleNetworkRequest = () => {
        fetch(createCreateCheckoutSessionURL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
                customer_ID : customerID,
                price: priceIDToSend,
              subscription_length: subscription_length,
              tier:tier,
              founders:isFoundersClub,
              isReturningCustomer: isReturningCustomer
            })
          })
          .then(res => {
            setIsSubmitting(false)
            console.log("Status code: " + res.status);
        
            if (!res.ok) {
              return res.json().then(json => {
                throw json; // Ensures it goes to catch block
              });
            }
        
            return res.json();
          })
          .then(({ url }) => {
            window.location = url;
          })
          .catch(e => {
            setIsSubmitting(false)
            setErrorMessage(e.error || "Something went wrong"); // Fallback message
          });
    }

    return(
      <div>
      <h1 className="header"> Renew Your Subscription </h1>

      <div className="background">

      <label>
        Tier
        <select value={tier} onChange={(e) => setTier(e.target.value)}>
        <option value="">-- Select a Tier --</option>
        <option value= "1"> Basic</option>
        <option value="2">
          {isFoundersClub ? "Pro - Founders' Club" : "Pro"}
        </option>
        </select>
      </label>

      <label>
        Length
        <select value={subscription_length} onChange={(e) => setSubscription_length(e.target.value)}>
        <option value="">-- Select a Length --</option>
        <option value= "1 Month"> Monthly</option>
        <option value= "12 Months"> Annual</option>
        </select>
      </label>


      <label className="link">
      <a href="https://www.theclassplan.com/pricing/"> See our pricing here </a>
      </label>

      <div className="errorMessage">
                    {errorMessage}
        </div>     

    

       <button className="submitButton" disabled={isSubmitting} onClick={() => handleSubmit()}>
        Checkout
       </button>

       
      </div>
      </div>
    )
}